var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"brains-tabs-details--tab",class:{ 'brains-tabs-details--tab__no-padding' : !_vm.padding }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }